import React, { useMemo } from 'react';

// Styles
import styles from './PatientChartButtons.module.css';

// Components
import ChartButton from '../../UI/ChartButton/ChartButton';

// Language
import { useTranslation } from 'react-i18next';

// Interfaces
import { Parameter } from '../../../interfaces/Profile';
interface ButtonChart {
    id: string,
    indicators: string[]
    color: string,
    text: string
}


const PatientChartButtons: React.FC<{
    sheetParameters: Parameter[]
    activeIndicators: string[]
    setActiveIndicators: React.Dispatch<React.SetStateAction<string[]>>
}> = ({ sheetParameters, activeIndicators, setActiveIndicators }) => {

    const { t } = useTranslation();

    const buttons: ButtonChart[] = useMemo(() => {

        if (sheetParameters === null) return [];

        const params = sheetParameters.map(p => {
            if (p.id === 'PA_D' || p.id === 'PA_S') return { // pirula para meter las dos PA en un mismo gráfico
                id: p.id,
                indicators: ['PA_D', 'PA_S'],
                color: '#ffd300',
                text: t('blood_pressure')
            };
            return {
                id: p.id,
                indicators: [p.id],
                color: p.color ?? '#f00',
                text: p.name ?? ''
            };
        });

        const filterDoubledPA = sheetParameters.some(p => p.id === 'PA_D') && sheetParameters.some(p => p.id === 'PA_S');

        return filterDoubledPA ? params.filter(p => p.id !== 'PA_D') : params;

    }, [sheetParameters, t]);


    const handleClickButton = (button: ButtonChart) => {
        setActiveIndicators(button.indicators);
    };

    return (
        <div className={styles.container}>
            {buttons.map(button =>
                <ChartButton
                    key={button.id}
                    button={button}
                    activeButton={activeIndicators.includes(button.id)}
                    onClick={() => handleClickButton(button)}
                />
            )}
        </div>
    );
};

export default PatientChartButtons;